import throttle from 'lodash/throttle';
import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../Reducers/Index'
import LocalStorage from '../../utils/localStorage';
import { isDevelopment } from '../../utils/general';
import { composeWithDevTools } from 'redux-devtools-extension';
const configureStore = (preloadedState) => {
  const stateFromLocalStorage = LocalStorage.loadState('app-store')?.state;
  const campaignLocalStorage = LocalStorage.loadState('campaignState');
  const persistedState = {
    ...preloadedState,
    ...stateFromLocalStorage,
    ...campaignLocalStorage
  };
  const middlewares = [thunkMiddleware];
  if (isDevelopment) {
    const { logger } = require(`redux-logger`);
    // middlewares.push(logger);
  }
  let store;
  if (isDevelopment) {
    store = createStore(
      rootReducer,
      persistedState,
      composeWithDevTools(
        applyMiddleware(...middlewares),
      ),
    );
  }
  else {
    store = createStore(
      rootReducer,
      persistedState,
      compose(
        applyMiddleware(...middlewares),
      ),
    );
  }
  store.subscribe(throttle(() => {
    LocalStorage.saveState({
      state: {
        auth: {
          ...store.getState().auth,
          url: '/',
          message: '',
        },
        user: {
          info: store.getState().user.info
        }
      }
    }, 'app-store');
  }, 1000));
  store.subscribe(throttle(() => {
    LocalStorage.saveState({
      campaign: {
        ...store.getState().campaign,
      }

    }, 'campaignState');
  }, 1000));
  return store;
};
export default configureStore;
